import { type FC } from 'react'

import { Shift } from '@api'

import { Button } from '@/components/ui/button'
import { Dialog } from '@/components/ui/dialog'

import { weekDays } from '../../consts'
import type { MutateRepeatableShiftTarget } from '../../types'
import { formatLocally } from '../../utils'

interface Props {
  shift: Shift
  isOpen: boolean
  onClose: () => void
  onDelete: (target: MutateRepeatableShiftTarget) => void
  isDeleting: boolean
}

export const DeleteRepeatableShiftDialog: FC<Props> = ({
  shift,
  onClose,
  onDelete,
  isOpen,
  isDeleting,
}: Props) => {
  const repetition = shift.days?.length === weekDays.length ? 'daily' : 'weekly'
  const endDate =
    shift.repeatedUntil &&
    formatLocally(new Date(shift.repeatedUntil), 'd LLL yyyy')

  let subtitle = `This shift is currently recurring ${repetition}`

  if (endDate) {
    subtitle += ` until ${endDate}`
  }

  return (
    <Dialog
      show={isOpen}
      onClose={onClose}
      bigDialog
    >
      <Dialog.Header>
        <Dialog.Title>This is a {repetition} recurring shift</Dialog.Title>
      </Dialog.Header>
      <Dialog.Description className="mt-4 block space-y-6 text-center text-title">
        {subtitle}
      </Dialog.Description>
      <Dialog.Description className="mt-6 block space-y-6 text-center text-title">
        Do you want to delete just this shift or all upcoming shifts?
      </Dialog.Description>
      <Dialog.ClosableFooter
        onClose={onClose}
        className="grid-cols-3"
      >
        <Button
          onClick={() => onDelete('Shift')}
          variant="destructive"
          isLoading={isDeleting}
        >
          Delete just this shift
        </Button>
        <Button
          onClick={() => onDelete('All')}
          isLoading={isDeleting}
          variant="destructive"
        >
          Delete all upcoming shifts
        </Button>
      </Dialog.ClosableFooter>
    </Dialog>
  )
}
